// eslint-disable-next-line import/no-cycle
import store from '@/store';
import PassThrough from '@/components/PassThrough.vue';

const SignUp = () => import(/* webpackChunkName: "group-auth" */ '@/pages/SignUp.vue');
const SignIn = () => import(/* webpackChunkName: "group-auth" */ '@/pages/SignIn.vue');
const CompleteSignUp = () => import(/* webpackChunkName: "group-auth" */ '@/pages/CompleteSignUp.vue');
const RestorePassword = () => import(/* webpackChunkName: "group-auth" */ '@/pages/RestorePassword.vue');
const ResetPassword = () => import(/* webpackChunkName: "group-auth" */ '@/pages/ResetPassword.vue');
const AfterSignUp = () => import(/* webpackChunkName: "group-auth" */ '@/pages/AfterSignUp.vue');

export default {
  path: 'auth',
  component: PassThrough,
  children: [
    {
      path: 'signup',
      name: 'SignUp',
      component: SignUp,
      meta: {
        requiresToBeSignedOut: true,
      },
    },
    {
      path: 'signup/with-email',
      name: 'SignUpWithEmail',
      component: SignUp,
      meta: {
        requiresToBeSignedOut: true,
      },
    },
    {
      path: 'signup/complete',
      name: 'CompleteSignUp',
      component: CompleteSignUp,
    },
    {
      path: 'signin',
      name: 'SignIn',
      component: SignIn,
      meta: {
        requiresToBeSignedOut: true,
      },
    },
    {
      path: 'signin/with-email',
      name: 'SignInWithEmail',
      component: SignIn,
      meta: {
        requiresToBeSignedOut: true,
      },
    },
    {
      path: 'password/restore',
      name: 'RestorePassword',
      component: RestorePassword,
    },
    {
      path: 'password/reset',
      name: 'ResetPassword',
      component: ResetPassword,
      props: true,
    },
    {
      path: 'welcome',
      name: 'Welcome',
      component: AfterSignUp,
      beforeEnter: (to, from, next) => {
        const { signUpEmail } = store.getters;
        if (!signUpEmail) {
          next({ name: 'Homepage' });
          return;
        }
        next();
      },
    },
  ],
};
